module.exports = __webpack_public_path__ + "assets/img/new34.4a1e3b25.png";